import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import type { PageData } from '@cng/shared';
import './styles/index.css';

const initialData: PageData | null = window.__CNG_DATA__ ?? null;
const container = document.getElementById('root')!;

const tree = (
  <StrictMode>
    <BrowserRouter>
      <App initialData={initialData} />
    </BrowserRouter>
  </StrictMode>
);

// Admin routes and SSR-disabled builds ship an empty shell, so there is nothing
// to hydrate; everything else was server-rendered and must be hydrated in place.
if (container.innerHTML.trim().length > 0) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}

/*
 * In development the server inlines the page's CSS so the first paint is styled
 * (see collectDevStyles in server/src/ssr.ts). Vite has now injected its own
 * copy and owns hot updates, so the server's snapshot is dropped — left in
 * place it would keep applying rules deleted since the page was served.
 *
 * `import.meta.env.DEV` is statically false in a production build, so this
 * whole block is removed by the bundler.
 */
if (import.meta.env.DEV) {
  requestAnimationFrame(() => {
    document.querySelectorAll('[data-cng-dev-styles]').forEach((el) => el.remove());
  });
}
